import React from 'react';
import {Button as MuiButton, ButtonProps} from '@mui/material';
import clsx from 'clsx';
import styles from './button.module.scss';

export interface CustomButtonProps extends ButtonProps {
  onClick?: (value?:any) => void;
}

export const Button = (props:CustomButtonProps) => {
  const {className: classes, color, fullWidth, variant, ...rest} = props;
  return (
    <MuiButton
      className={
        clsx(
          styles.button,
          props.size === 'small' && styles.small,
          props.size === 'large' && styles.large,
          props.color === 'primary' && styles.primary,
          props.color === 'secondary' && styles.secondary,
          props.color === 'inherit' && styles.inherit,
          props.variant === 'outlined' && styles.outlined,
          props.variant === 'text' && styles.text,
          props.fullWidth && styles.fullWidth,
          'jc-button',
          classes
        )
      }
      {...rest}>{props.children}</MuiButton>
  )
}

export default Button;
